import { constructionSafety, logisticsAsset, manufacturingSteel } from '@pages/Enterprise/Solution/components/Banner/BannerImages';
import productImg from '../main/product/productImg';
import productPurchase from '../main/product/productPurchase';

import video from '@src/assets/images/solution/logisticsAsset/video/rtlsVideo.mp4';

export default {
  desc: 'Chuyển đổi số là quá trình thay thế hoặc cải thiện các quy trình và mô hình kinh doanh hiện có bằng công nghệ kỹ thuật số. Đây là quá trình nâng cấp các phương thức làm việc truyền thống lên những phương thức hiện đại và hiệu quả hơn, đồng thời tìm kiếm cơ hội trong tương lai thông qua việc ứng dụng công nghệ số.',
  keywords: 'Chuyển đổi số, bản sao số, thành phố thông minh, Orbro, chuyen doi so, ban sao so, thanh pho thong minh, Orbro.',
  ogSite: 'Chuyển đổi số (DX) là gì?',
  title: 'Chuyển đổi số (DX) là gì?',
  ogUrl: 'https://orbro.io/vi/blog/dx',
  ogImg: '',
  ogType: 'website',
  date: '2023-11-01',
  tag1: '#Chuyendoiso',
  tag2: '#Bansaoso',
  tag3: '#Thanhphothongminh',
  tag4: '#Orbro',
  text: [
    {
      head: '',
      subHead: '',
      desc: 'Chuyển đổi số là quá trình thay thế hoặc cải thiện các quy trình và mô hình kinh doanh hiện có bằng công nghệ kỹ thuật số. Đây là quá trình nâng cấp các phương thức làm việc truyền thống lên những phương thức hiện đại và hiệu quả hơn, đồng thời tìm kiếm cơ hội trong tương lai thông qua việc ứng dụng công nghệ số. Chuyển đổi số đang tác động đến nhiều ngành và lĩnh vực khác nhau, từ doanh nghiệp đến chính phủ, y tế, giáo dục và nhiều ngành khác, và tầm quan trọng của nó vẫn đang không ngừng gia tăng.\nCác mục tiêu cốt lõi của chuyển đổi số bao gồm như sau.\n',
      dot: '',
    },
    {
      head: '',
      subHead: 'Nâng cao hiệu quả',
      desc: 'Tăng năng suất và giảm chi phí thông qua các quy trình và phương thức làm việc tốt hơn.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Cải thiện trải nghiệm khách hàng',
      desc: 'Cung cấp dịch vụ và trải nghiệm tốt hơn cho khách hàng thông qua công nghệ số.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Thúc đẩy đổi mới sáng tạo',
      desc: 'Phát triển ý tưởng và mô hình kinh doanh mới để đảm bảo năng lực cạnh tranh trên thị trường.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Khai thác dữ liệu',
      desc: 'Thu thập, phân tích và ứng dụng dữ liệu để hỗ trợ việc ra quyết định.',
      dot: '',
    },
    {
      head: 'RTLS và Digital Twin (Bản sao số)',
      subHead: '',
      desc: 'Công nghệ Hệ thống định vị thời gian thực (RTLS) là một trong những thành phần cốt lõi của chuyển đổi số, đây là công nghệ xác định chính xác vị trí của vật thể, tài nguyên hoặc con người trong không gian vật lý. RTLS thu thập và cung cấp thông tin vị trí theo thời gian thực thông qua cảm biến, truyền thông không dây, phân tích dữ liệu và công nghệ trực quan hóa.\nDigital Twin (Bản sao số) có mối liên hệ chặt chẽ với công nghệ RTLS. Digital Twin là một bản sao kỹ thuật số của một thực thể vật lý trong thế giới thực, qua đó cho phép theo dõi và mô phỏng trạng thái, vị trí và tương tác của đối tượng vật lý theo thời gian thực. Công nghệ RTLS cung cấp dữ liệu thiết yếu để duy trì và cập nhật Digital Twin.',
      dot: '',
    },
    {
      head: 'Trường hợp thực tế',
      subHead: '',
      desc: 'Khi được phản ánh vào Digital Twin, trạng thái vật lý của hiện trường công nghiệp có thể được mô phỏng bằng kỹ thuật số. Trong ngành sản xuất, công nghệ này được sử dụng để theo dõi và tối ưu hóa chuyển động của dây chuyền sản xuất; trong lĩnh vực y tế, nó được dùng để theo dõi vị trí bệnh nhân và quản lý thiết bị y tế. Ngoài ra, trong các dự án thành phố thông minh, nó được áp dụng để cải thiện giao thông đường bộ và quản lý thiên tai; trong lĩnh vực logistics và phân phối, nó giúp tối ưu hóa việc quản lý hàng tồn kho và xử lý đơn hàng.\nVí dụ, khi các robot tự động cố định di chuyển và sắp xếp hàng hóa, công nghệ RTLS có thể theo dõi vị trí của những robot này và thông qua Digital Twin, xây dựng các mô hình dự đoán để tránh va chạm và tối ưu hóa lộ trình. Hơn nữa, nó giúp tối ưu hóa mức tồn kho, phòng ngừa các vấn đề thiếu hụt hoặc tồn kho quá nhiều, và việc tận dụng những hiểu biết sâu sắc dựa trên dữ liệu này có thể nâng cao hiệu quả của quy trình logistics và cải thiện chất lượng dịch vụ khách hàng.',
      dot: '',
    },
    {
      head: 'Kết luận',
      subHead: '',
      desc: 'Chuyển đổi số (DX) đang nổi lên như một yếu tố quan trọng cho sự tồn tại và phát triển của các doanh nghiệp và tổ chức trong xã hội hiện đại. Công nghệ RTLS và Digital Twin là một trong những công nghệ cốt lõi dẫn dắt quá trình chuyển đổi này, đóng vai trò quan trọng trong việc chuẩn bị cho tương lai bằng cách biến đổi thế giới vật lý thành kỹ thuật số. Thông qua chuyển đổi số, chúng ta sẽ có thể nâng cao hiệu quả và chuẩn bị cho những thách thức trong tương lai.',
      dot: '',
    },
  ],

  link: {
    page: 'rtls',
    numb: '1',
    product: [
      {
        text: productPurchase.purchase.ble.bleStarterKit.title,
        title: productPurchase.purchase.ble.bleStarterKit.title,
        serial: productPurchase.purchase.ble.bleStarterKit.serial,
        desc: 'Sản phẩm này giúp gắn thiết bị UWB lên nhân viên hoặc thiết bị, hỗ trợ theo dõi vị trí theo thời gian thực.',
        img: productImg.product.bleStarterKit.key1,
      },
      {},
    ],
    solution: [
      {
        img: constructionSafety.thumb,
        data: 'constructionSafety',
        link: '/vi/enterprise/construction/safety',
      },
      {
        img: logisticsAsset.thumb,
        data: 'logisticsAsset',
        link: '/vi/enterprise/logistics/asset',
      },
      {
        img: manufacturingSteel.thumb,
        data: 'manufacturingSteel',
        link: '/vi/enterprise/manufacturing/steel',
      },
    ],
  },
};
